export const apiConfig = {
	apiLanguage: document.documentElement.dataset.apilanguage,
	apiNode: document.documentElement.dataset.apinode,
	country: document.documentElement.dataset.country,
	culture: document.documentElement.dataset.culture,
	lang: document.documentElement.dataset.lang,
};
